module.exports = __webpack_public_path__ + "static/media/1_A1_04.c497a64f.png";